import React, { forwardRef } from "react";
import { OutlinedInput, OutlinedInputProps, Typography } from "@mui/material";

interface TextInputWithCounterProps extends OutlinedInputProps {
    maxLength?: number;
}

// <OutlinedInput> com contador de caracteres embaixo, refletindo o tamanho
// máximo da coluna no banco (só faz sentido para campos de texto limitados).
export const TextInputWithCounter = forwardRef<HTMLInputElement, TextInputWithCounterProps>(
    ({ maxLength, value, ...rest }, ref) => (
        <React.Fragment>
            <OutlinedInput
                ref={ref}
                value={value}
                inputProps={maxLength ? { maxLength } : undefined}
                {...rest}
            />
            {maxLength !== undefined && (
                <Typography variant="caption" color="text.secondary">
                    {String(value ?? '').length}/{maxLength} caracteres
                </Typography>
            )}
        </React.Fragment>
    )
);

TextInputWithCounter.displayName = 'TextInputWithCounter';

export default TextInputWithCounter;
